module.exports = __webpack_public_path__ + "static/blog-img1-fd5e6c6e4a62cee2e34c081223c73ba1.jpg";